import * as React from 'react';
import { observer } from 'mobx-react';
import { ButtonCircle } from './button-circle';
import { SVGIcon } from './svg-icon';
import { classes, style } from 'typestyle';
import { shadowSubtle } from '../theme/shadow';
import { transitionQuickEase } from '../theme/transition';
import {colorBlack, colorBrand, colorContrast, colorSubtle, colorWhite} from '../theme/color';
import {em, important, percent, px, rem} from 'csx';
import { animationPulse } from '../theme/animation';
import {fontSerif} from '../theme/font';


export interface ButtonInfoProps {
  className?: string;
  onClick?(event: React.MouseEvent<any>): void;
  isActive?: boolean;
  size?: number;
}

@observer
export class ButtonInfo extends React.Component<ButtonInfoProps, any> {
  render() {
    const { isActive, size, className, onClick } = this.props;

    const cz = classes(
      ButtonInfo.styles.container,
      isActive
        ? ButtonInfo.styles.containerActive
        : ButtonInfo.styles.containerInactive,
      className
    );

    return (
      <ButtonCircle className={cz} size={size} onClick={onClick}>
        i
      </ButtonCircle>
    )
  }

  static defaultProps = {
    size: 28,
    open: false
  };

  static i18n = {};

  static styles = {
    container: style({
      zIndex: 1,
      userSelect: 'none',
      fontFamily: fontSerif,
      fontStyle: 'italic',
      fontWeight: 600,
      fontSize: em(0.75),
      boxShadow: shadowSubtle,
      position: 'relative',
      $nest: {
        '& path': {
          transition: `all ${transitionQuickEase}`
        },
        '& svg': {
          marginTop: em(1/16),
          transition: `all ${transitionQuickEase}`
        },
        '& span': {
          transition: `all ${transitionQuickEase}`
        }
      }
    }),
    containerActive: style({
      color: colorWhite.toString(),
      background: colorBrand.toString(),
      $nest: {
        '&::after': {
          position: 'absolute',
          display: 'block',
          content: '""',
          width: percent(100),
          zIndex: 0,
          background: colorSubtle.fade(0.075).toString(),
          top: percent(50),
          height: rem(2)
        }
      }
    }),
    containerInactive: style({
      color: colorBrand.toString(),
      background: colorWhite.toString(),
    })
  };
}